import { AppSettings } from '../../../settings';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AverageTrafficSummary } from '../../average-traffic/average-traffic.model';

@Injectable()
export class ReportsService {
  constructor(
    private _httpClient: HttpClient,
    private _appsettings: AppSettings
  ) { }

  httpGetPartialReport(dateFrom?: Date, dateTo?: Date, partnerId?: number, costCenterId?: number) {
    let httpParams = new HttpParams();
    if (dateFrom !== null)
      httpParams = httpParams.set('DateFrom', dateFrom.toJSON());
    if (dateTo !== null)
      httpParams = httpParams.set('DateTo', dateTo.toJSON());
    if (partnerId !== null && partnerId !== undefined) {
      httpParams = httpParams.set('Type', '1');
      httpParams = httpParams.set('TypeIdentity', partnerId.toString());
    }
    if (costCenterId !== null && costCenterId !== undefined) {
      httpParams = httpParams.set('Type', '0');
      httpParams = httpParams.set('TypeIdentity', costCenterId.toString());
    }
    httpParams = httpParams.set('AccountingType', '2');

    return this._httpClient.get<any[]>(this._appsettings.apiUrl + 'reports/partialReports', {
      observe: 'body',
      responseType: 'json',
      params: httpParams
    }).map(
      (response) => {
        return response;
    });
  }

  httpGetTerminalActionsSsbtReport(dateFrom: Date, dateTo: Date, costCenterId: number, terminalActionTypeId?: number) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('DateFrom', dateFrom.toJSON());
    httpParams = httpParams.set('DateTo', dateTo.toJSON());
    httpParams = httpParams.set('CostCenterId', costCenterId.toString());
    if (terminalActionTypeId != null)
      httpParams = httpParams.set('TerminalActionTypeId', terminalActionTypeId.toString());

    return this._httpClient.get<any[]>(this._appsettings.apiUrl + 'reports/terminalActionsSsbtReport', {
      observe: 'body',
      responseType: 'json',
      params: httpParams
    }).map(
      (response) => {
        return response['terminalActionsSsbtReports'];
    });
  }

  httpGetTerminalActionTypes() {
    return this._httpClient.get<any[]>(this._appsettings.apiUrl + 'reports/terminalActionTypes', {
      observe: 'body',
      responseType: 'json'
    }).map(
      (response) => {
        const terminalActionTypes: Array<any> = response['terminalActionTypes'];
        return terminalActionTypes;
    });
  }

  httpGetTerminalActionReportItemAsHtml(date: Date, costCenterId: number, terminalActionTypeId: number, amount: number, newState: number, language: string) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('Date', new Date(date).toJSON());
    httpParams = httpParams.set('CostCenterId', costCenterId.toString());
    httpParams = httpParams.set('ActionType', terminalActionTypeId.toString());
    httpParams = httpParams.set('CurrentValue', newState.toString());
    httpParams = httpParams.set('ChangeValue', amount.toString());
    httpParams = httpParams.set('Language', language.toString());

    return this._httpClient.get(this._appsettings.apiUrl + 'reports/printTerminalAction', {
      observe: 'body',
      responseType: 'text',
      params: httpParams
    }).map(
      (response) => {
        return response;
    });
  }

  httpGetPartialReportItemAsHtml(costCenterId: number, accountingId: number, language: string) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('CostCenterId', costCenterId.toString());
    httpParams = httpParams.set('AccountingId', accountingId.toString());
    httpParams = httpParams.set('Language', language.toString());

    return this._httpClient.get(this._appsettings.apiUrl + 'reports/printPartialReport', {
      observe: 'body',
      responseType: 'text',
      params: httpParams
    }).map(
      (response) => {
        return response;
    });
  }

  httpGetTerminalConnectivityStatusesReport(zoneIds: number[], terminalConnectionStatusId?: number) {
    let httpParams = new HttpParams();
    zoneIds.forEach(zoneId => {
      httpParams = httpParams.append('ZoneIds', zoneId.toString());
    });
    if (terminalConnectionStatusId !== undefined && terminalConnectionStatusId !== null)
      httpParams = httpParams.set('LocationStatus', terminalConnectionStatusId.toString());

    return this._httpClient.get<any[]>(this._appsettings.apiUrl + 'reports/terminalActivityStates', {
      observe: 'body',
      responseType: 'json',
      params: httpParams
    }).map(
      (response) => {
        return response['terminalActivityStates'];
    });
  }

  httpGetCostCenterTraffic(costCenterId: number) {
    let httpParams = new HttpParams();
    const now = new Date();
    httpParams = httpParams.set('CostCenterId', costCenterId.toString());
    httpParams = httpParams.set('Date', now.toJSON());

    return this._httpClient.get<AverageTrafficSummary>(this._appsettings.apiUrl + 'reports/costCenterTraffic', {
        observe: 'body',
        responseType: 'json',
        params: httpParams
    }).map(
        (response) => {
            return response['report'];
        });
  }

  httpGetTerminalOverviewReport(zoneIds: number[], groupIds: string[]) {
    let httpParams = new HttpParams();
    zoneIds.forEach(zoneId => {
      httpParams = httpParams.append('ZoneIds', zoneId.toString());
    });
    groupIds.forEach(groupId => {
      httpParams = httpParams.append('Groups', groupId);
    });

    return this._httpClient.get<any[]>(this._appsettings.apiUrl + 'reports/terminalOverviewReport', {
      observe: 'body',
      responseType: 'json',
      params: httpParams
    }).map(
      (response) => {
        return response['terminalOverviews'];
    });
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/reports/report.service.ts